import React, { useState, useContext } from "react";
import { Button, Menu, MenuItem } from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import "./FilterMenu.css";
import FilterContext from "../StateManagement/Context";

function FilterMenu({
  role,
  loggedInUser,
  allUsers,
  statusFilter,
  userFilter
}) {

  const { updateCaseFilters } = useContext(FilterContext);
  const [anchorEl, setAnchorEl] = useState(null);

  const [selectedStatus, setSelectedStatus] = useState(
    statusFilter ??
    (role == "Admin" ? "Data Entry Pending" : "All")
  );
  const [selectedUser, setSelectedUser] = useState(
    userFilter ??
    (role == "Admin" ? "All" : loggedInUser)
  );

  const getUserName = (user) => {
    return user.emailId.split("@")[0];
  };
  const handleFilterUpdate = () => {
    updateCaseFilters("filterStatus", selectedStatus);
    updateCaseFilters("filterUser", selectedUser);
    // setFilterStatus(selectedStatus);
    // setFilterUser(selectedUser);
  };

  const handleStatusUpdate = (status) => {
    updateCaseFilters("filterStatus", status);
  }
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  //separate menus for admin and QC user
  const AdminMenu = () => {
    return (
      <div>
        <div className="status-admin">
          <h3>Status</h3>
          <MenuItem
            style={{ justifyContent: "center", paddingBottom: 10 }}
            selected={selectedStatus === "All" ? true : false}
            onClick={(e) => {
              setSelectedStatus("All");
              handleStatusUpdate("All")
            }}
          >
            All Pending
          </MenuItem>
          <MenuItem
            style={{ justifyContent: "center", paddingBottom: 10 }}
            selected={selectedStatus === "Data Entry Pending" ? true : false}
            onClick={(e) => {
              setSelectedStatus(e.target.innerText);
              handleStatusUpdate(e.target.innerText)
            }}
          >
            Data Entry Pending
          </MenuItem>
          <MenuItem
            style={{ justifyContent: "center", paddingBottom: 10 }}
            selected={selectedStatus === "Doctor Entry Pending" ? true : false}
            onClick={(e) => {
              setSelectedStatus(e.target.innerText);
              handleStatusUpdate(e.target.innerText)
            }}
          >
            Doctor Entry Pending
          </MenuItem>
          <MenuItem
            style={{ justifyContent: "center", paddingBottom: 10 }}
            selected={selectedStatus === "QC Pending" ? true : false}
            onClick={(e) => {
              setSelectedStatus(e.target.innerText);
              handleStatusUpdate(e.target.innerText)
            }}
          >
            QC Pending
          </MenuItem>
          <MenuItem
            style={{ justifyContent: "center", paddingBottom: 10 }}
            selected={selectedStatus === "INCOMPLETE" ? true : false}
            onClick={(e) => {
              setSelectedStatus(e.target.innerText);
              handleStatusUpdate(e.target.innerText)
            }}
          >
            INCOMPLETE
          </MenuItem>
          <MenuItem
            style={{ justifyContent: "center", paddingBottom: 10 }}
            selected={selectedStatus === "VERIFIED" ? true : false}
            onClick={(e) => {
              setSelectedStatus(e.target.innerText);
              handleStatusUpdate(e.target.innerText)
            }}
          >
            VERIFIED
          </MenuItem>
        </div>

        <div className="user-admin">
          <h3>User</h3>
          <MenuItem
            style={{ justifyContent: "center", paddingBottom: 10 }}
            selected={selectedUser === "All" ? true : false}
            onClick={(e) => {
              setSelectedUser("All");
            }}
          >
            All users
          </MenuItem>
          <MenuItem
            style={{ justifyContent: "center", paddingBottom: 10 }}
            selected={selectedUser === "" ? true : false}
            onClick={(e) => {
              setSelectedUser("");
            }}
          >
            Unallocated
          </MenuItem>
          {
          allUsers.map((user, index) => {
            if (!user.isTechTeam) {
              return (
                <MenuItem
                  style={{ justifyContent: "center", paddingBottom: 10 }}
                  selected={selectedUser === getUserName(user) ? true : false}
                  onClick={(e) => {
                    setSelectedUser(getUserName(user));
                  }}
                >
                  {getUserName(user)}
                </MenuItem>
              );
            }
          })}
        </div>
      </div>
    );
  };

  const UserMenu = () => {
    return (
      <div>
        <div className="status-qc">
          <h3>Status</h3>
          <MenuItem
            style={{ justifyContent: "center", paddingBottom: 10 }}
            selected={selectedStatus === "All" ? true : false}
            onClick={(e) => {
              setSelectedStatus("All");
              handleStatusUpdate("All")
              setSelectedUser(loggedInUser);
            }}
          >
            All Pending
          </MenuItem>
          <MenuItem
            style={{ justifyContent: "center", paddingBottom: 10 }}
            selected={selectedStatus === "Data Entry Pending" ? true : false}
            onClick={(e) => {
              setSelectedStatus(e.target.innerText);
              handleStatusUpdate(e.target.innerText)
            }}
          >
            Data Entry Pending
          </MenuItem>
          <MenuItem
            style={{ justifyContent: "center", paddingBottom: 10 }}
            selected={selectedStatus === "Doctor Entry Pending" ? true : false}
            onClick={(e) => {
              setSelectedStatus(e.target.innerText);
              handleStatusUpdate(e.target.innerText)
            }}
          >
            Doctor Entry Pending
          </MenuItem>
          <MenuItem
            style={{ justifyContent: "center", paddingBottom: 10 }}
            selected={selectedStatus === "QC Pending" ? true : false}
            onClick={(e) => {
              setSelectedStatus(e.target.innerText);
              handleStatusUpdate(e.target.innerText)
            }}
          >
            QC Pending
          </MenuItem>
          <MenuItem
            style={{ justifyContent: "center", paddingBottom: 10 }}
            selected={selectedStatus === "INCOMPLETE" ? true : false}
            onClick={(e) => {
              setSelectedStatus(e.target.innerText);
              handleStatusUpdate(e.target.innerText)
            }}
          >
            INCOMPLETE
          </MenuItem>
          <MenuItem
            style={{ justifyContent: "center", paddingBottom: 10 }}
            selected={selectedStatus === "VERIFIED" ? true : false}
            onClick={(e) => {
              setSelectedStatus(e.target.innerText);
              handleStatusUpdate(e.target.innerText)
            }}
          >
            VERIFIED
          </MenuItem>
        </div>
      </div>
    );
  };

  return (
    <div>
      <Button
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        variant="contained"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
        endIcon={<KeyboardArrowDownIcon />}
      >
        Filter
      </Button>
      <Menu
        PaperProps={{
          sx: { position: "absolute", width: "20rem", maxHeight: "300px" },
        }}
        className="menu-container"
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
      >
        {role === "Admin" ? <AdminMenu /> : <UserMenu />}
        <div className="footer">
          <Button variant="contained" onClick={handleFilterUpdate}>
            Save
          </Button>
        </div>
      </Menu>
    </div>
  );
}

export default FilterMenu;
